var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0123 38.75C21.0478 38.75 26.7511 33.1536 26.7511 26.25C26.7511 19.3464 21.0478 13.75 14.0123 13.75C6.97682 13.75 1.27344 19.3464 1.27344 26.25C1.27344 33.1536 6.97682 38.75 14.0123 38.75Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45178 15.825C1.32439 15.15 1.27344 14.45 1.27344 13.725C1.27344 6.85 6.98044 1.25 14.0123 1.25C21.0441 1.25 26.7511 6.85 26.7511 13.75C26.7511 14.475 26.7002 15.15 26.5728 15.85",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBals);
export default __webpack_public_path__ + "static/media/bals.960f01e14a40dd5e20b0fcabc9d42cac.svg";
export { ForwardRef as ReactComponent };